/* eslint-disable */
const api = {
  getTableData: '/admin/platformSet/getData', // 获取数据
};
export default api;
